import sessionService from "./session-service";

export const getAssignmentThumbnailSource = (item = {}) => {
  const { thumbnailPath, resourceId, containerName } = item;

  if (
    !thumbnailPath ||
    !/^https?:\/\//i.test(thumbnailPath) ||
    !resourceId ||
    !containerName
  ) {
    return thumbnailPath;
  }

  const token = sessionService.getSasTokens(resourceId, containerName);
  return token ? `${thumbnailPath}${token}` : thumbnailPath;
};
